class Helper {
    static GetDateDDMMYYYY(date){
        if(date == "0000-00-00"){
            return "-"
        }
        const today = new Date(date)
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = dd + '/' + mm + '/' + yyyy;
        return formattedToday;
    }

    static GetDateYYYYMMDD(date){
        
        const today = new Date(date)
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = yyyy + '-' + mm + '-' + dd;
        return formattedToday;
    }

    static  DateDDMMYYYYtoYYYYMMDD(date){
            let data = String(date).split('/')
            return data[2] + "-" + data[1] + "-" + data[0].trim()
    } 

    static formatAsCurrency = (value, locale = 'en-US') => {
        return new Intl.NumberFormat(locale).format(value);
      };

      static SetReturnUrl(){
     
        return "?ReturnUrl=" + window.location.pathname.substring(1, window.location.pathname.length) + window.location.search; 
      }
 

    static GetDay(date1 ,date2){
        var newDate = new Date(date1)
        var countDay = 0;
        while (newDate <= new Date(date2)) {
            if(newDate.getDay() != 0 && newDate.getDay() != 6){
                countDay++;
            }
            newDate.setDate(newDate.getDate() + 1);
        }

        return countDay;
    }

    static ArraySort(arr, key, type="asc"){
        if(type == "asc"){
            return arr.sort((a,b)=>  !isNaN(Number(this.getKeyVal(a,key)))  ? this.getKeyVal(a, key) - this.getKeyVal(b,key) : this.getKeyVal(a, key).localeCompare(this.getKeyVal(b,key)))
        }
       
        return arr.sort((a,b)=> !isNaN(Number(this.getKeyVal(b,key)))  ? this.getKeyVal(b,key) - this.getKeyVal(a,key) : this.getKeyVal(b,key).localeCompare(this.getKeyVal(a,key)))
    }
 
     static getKeyVal(variable, key){
        for(let obj in variable){
             if(obj == key){
                return variable[obj] == null ? '' :  variable[obj];
             }
        }
    }

    static isDate(item) {
        if(new Date(item) == "Invalid Date") return item 
        return  item
    }

    static createOTP(){
        
    }

    static RemoveDuplicateArr(data){
        var temp= [];
       
        for(var i=0; i < data.length; i++) {
            if(temp.findIndex((x) =>x == data[i])  == -1) {
                temp.push(data[i]);
            }
        }
        return temp;
      }
   
}

export default Helper